import { FC, useEffect, useState, memo } from 'react'
import Image from 'next/image'
import Skeleton from 'react-loading-skeleton'
import clsx from 'clsx'

import { getAxiosSingle } from '../../../pages/api/axios'
import { URL_LIST } from '../../../constants/url'
import { STATIC_URL } from 'constants/data'

import styles from './subscribers-get.module.scss'

interface ISubscribersGet {
  id: number
  text: string
  modificator?: string
  noIcon?: boolean
  alwaysShow?: boolean
}

const SubscribersGet: FC<ISubscribersGet> = ({
  id,
  text,
  modificator,
  noIcon = false,
  alwaysShow,
}: ISubscribersGet) => {
  const [subscribers, setSubscribers] = useState(0)

  useEffect(() => {
    const getSubscribers = async () => {
      const query = `${URL_LIST.SUBSCRIBERS_COUNT}?type=WebinarId&id=${id}`
      const result = await getAxiosSingle(query)

      setSubscribers(result)
    }
    getSubscribers()
  }, [])

  if (!alwaysShow && subscribers === 0) return null

  return (
    (
      <div
        className={clsx(styles.subscribers, {
          [modificator as string]: modificator,
        })}
      >
        {!noIcon && (
          <div className={styles.icon}>
            <Image
              width="19"
              height="11"
              src={`${STATIC_URL}/cards/icon_subscribers.svg`}
              alt="количество подписавшихся"
            />
          </div>
        )}
        <b>{subscribers}</b>
        &nbsp;
        <span>{text}</span>
      </div>
    ) || <Skeleton width={50} />
  )
}

export default memo(SubscribersGet)
